import { useSyncExternalStore } from 'react';

const SIDEMENU_KEY = 'naia.sidemenu';

let open = false;
try {
  open = localStorage.getItem(SIDEMENU_KEY) === 'open';
} catch { /* ignore */ }

const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

function getSnapshot() {
  return open;
}

export function setSidemenuOpen(next: boolean | ((prev: boolean) => boolean)) {
  const value = typeof next === 'function' ? next(open) : next;
  if (value === open) return;
  open = value;
  try { localStorage.setItem(SIDEMENU_KEY, open ? 'open' : 'closed'); } catch { /* ignore */ }
  emit();
}

export function useSidemenuOpen(): [boolean, typeof setSidemenuOpen] {
  const value = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return [value, setSidemenuOpen];
}
